import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';

export default function FormDialog({
  open,
  onClose,
  title,
  children,
  onSubmit,
  submitText = "Save",
  loading = false,
  maxWidth = "sm",
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton onClick={onClose}>
          <Icon icon={closeFill} />
        </IconButton>
      </DialogTitle>
      <form onSubmit={onSubmit}>
        <DialogContent className='pt-1'>{children}</DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? 'Saving...' : submitText}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}